
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/initiative-search",
      function () {
        return require("private-next-pages/initiative-search.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/initiative-search"])
      });
    }
  